import { IApi, useClientApi } from '@/setup/api-client'
import { useApiQuery } from '@/utils/api/api-query'
import type {
    CreditHistoryData,
    CreditHistoryMeta,
    CreditHistoryQueryParams,
} from 'api/dist/routes/organization/[organization_id]/credits/history'

export interface IGetCreditHistoryQueryParams {
    organizationId: string
    page?: number
    limit?: number
    type?: CreditHistoryQueryParams['type']
}

export class GetCreditHistoryQuery {
    static getKey(params: IGetCreditHistoryQueryParams) {
        return [
            'organization',
            params.organizationId,
            'credits',
            'history',
            { page: params.page, limit: params.limit, type: params.type },
        ]
    }

    static async call(api: IApi, params: IGetCreditHistoryQueryParams) {
        const searchParams = new URLSearchParams()
        if (params.page) searchParams.set('page', params.page.toString())
        if (params.limit) searchParams.set('limit', params.limit.toString())
        if (params.type) searchParams.set('type', params.type)

        const queryString = searchParams.toString()
        const url = `/organization/${params.organizationId}/credits/history${queryString ? `?${queryString}` : ''}`

        return api.get<CreditHistoryData, CreditHistoryMeta>(url)
    }
}

export const useGetCreditHistoryQuery = (
    organizationId: string,
    options?: {
        page?: number
        limit?: number
        type?: CreditHistoryQueryParams['type']
        enabled?: boolean
    }
) => {
    const api = useClientApi()

    const params: IGetCreditHistoryQueryParams = {
        organizationId,
        page: options?.page,
        limit: options?.limit,
        type: options?.type,
    }

    return useApiQuery({
        queryKey: GetCreditHistoryQuery.getKey(params),
        queryFn: () => GetCreditHistoryQuery.call(api, params),
        enabled: options?.enabled !== false && !!organizationId,
    })
}

export type ICreditHistoryData = CreditHistoryData
export type ICreditHistoryMeta = CreditHistoryMeta
